import { Types } from '@store/types';

const initialState = [];

const UserReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_USER_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default UserReducer;
